import { render, staticRenderFns } from "./ContentHeadingsTable.vue?vue&type=template&id=4ba176a3&scoped=true&"
import script from "./ContentHeadingsTable.vue?vue&type=script&lang=ts&"
export * from "./ContentHeadingsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContentHeadingsTable.vue?vue&type=style&index=0&id=4ba176a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba176a3",
  null
  
)

export default component.exports
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMarkupTable});
